import { render } from "./ApiExceptionMessage.vue?vue&type=template&id=40c4790c"
import script from "./ApiExceptionMessage.vue?vue&type=script&lang=js"
export * from "./ApiExceptionMessage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__